import instructions from '../reducers/instructions'
import timer from '../reducers/timer'
import testpanel from '../reducers/testpanel'
import testDataConfirmation from '../reducers/testDataConfirmation'
import completion from '../reducers/complition'
import testStatus from '../reducers/teststatus'
import submittest from '../reducers/submittest'
import globalTestStatus from '../reducers/globalTestStatus'
import queryparam from '../reducers/queryparam'
import isExistingTest from '../reducers/isExistingTest'
import deviceId from '../reducers/deviceId'
import get_ip_address from '../reducers/get_ip_address'
import resumedData from '../reducers/resumedData'
import packageId from '../reducers/packageId'
import analytics from '../reducers/analytics'
import base_url from '../reducers/base_url'
import header_visible from '../reducers/header_visible'
import test_duration from '../reducers/test_duration'
import mock_test_submit from '../reducers/mock_test_submit'
import calculated_time_left from '../reducers/calculated_time_left'
import pushNotificationEvent from '../reducers/pushNotificationEvent'
import current_question from '../reducers/current_question'
import toggleStatus from '../reducers/toggleStatus'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import { SUBMIT_TEST } from '../constants/actionTypes'
import current_language from '../reducers/current_language'
import active_section from '../reducers/active_section'
import loading_percent from '../reducers/loading_percent'
import correct_otp from '../reducers/correct_otp'
import antheData from '../reducers/antheData'
import testpreview from '../reducers/testpreview'

const persistConfig = {
    key: 'root',
    storage: storageSession,
}

const rootReducer = combineReducers({
    analytics,
    instructions,
    timer,
    testpanel,
    completion,
    testStatus,
    submittest,
    testDataConfirmation,
    globalTestStatus,
    queryparam,
    isExistingTest,
    deviceId,
    resumedData,
    packageId,
    pushNotificationEvent,
    base_url,
    get_ip_address,
    test_duration,
    calculated_time_left,
    current_question,
    header_visible,
    current_language,
    active_section,
    loading_percent,
    correct_otp,
    antheData,
    testpreview,
    toggleStatus,
    mock_test_submit,
})

export default persistReducer(persistConfig, (state, action) =>
    rootReducer(action.type === SUBMIT_TEST ? undefined : state, action),
)
